<template>
  <td
    class="boss-center"
    data-test="message-td"
    :class="{ 'notice-background': !isMessageReplied }"
  >
    <Component
      :is="componentTag"
      data-test="message-link"
      v-bind="additionalProps"
      v-on="additionalListeners"
    >
      <span
        v-if="isEntryMessageReservationReserved"
        data-test="entry-message-reservation"
      >予約中<br></span>
      <span
        v-if="isMessageReplied"
        data-test="replied"
      >返信済み<br></span>
      <span
        v-else
        data-test="no-replied"
        class="boss-notice-text"
      >未返信<br></span>
      <div class="boss-layout boss-layout-vertical boss-layout-gap-small">
        <div
          v-if="receivedMessageCount"
          data-test="icon-wrap"
        >
          <img
            v-if="!isMessageRead"
            data-test="close-icon"
            src="@/assets/images/dm-close.svg"
          >
          <img
            v-else-if="isMessageRead && isMessageReplied"
            data-test="open-icon-inactive"
            src="@/assets/images/dm-open-gray.svg"
          >
          <img
            v-else-if="isMessageRead && !isMessageReplied"
            data-test="open-icon-active"
            src="@/assets/images/dm-open-red.svg"
          >
        </div>
        <span data-test="received-count">受信数({{ receivedMessageCount }})</span>
        <span data-test="latest-message">{{ latestMessage }}</span>
      </div>
    </Component>
  </td>
</template>

<script>
import _ from 'lodash'
import dayjs from 'dayjs'

export default {
  props: {
    message: {
      type: Object,
      required: true
    },
    entryId: {
      type: Number,
      required: false,
      default: null
    },
    isEntry: {
      type: Boolean,
      default: true
    },
    isEntryMessageReservationReserved: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 詳細画面への画面遷移ありかどうか
    canGoToEntryDetail () {
      return !!this.entryId
    },
    isMessageReplied () {
      return _.get(this.message, 'isReplied', false)
    },
    receivedMessageCount () {
      return _.get(this.message, 'receivedCount', 0)
    },
    isMessageRead () {
      return _.get(this.message, 'isRead', false)
    },
    latestMessage () {
      return dayjs(_.get(this.message, 'sendReceiveDateTime')).format('MM/DD')
    },
    componentTag () {
      return this.canGoToEntryDetail ? 'a' : 'span'
    },
    additionalProps () {
      return this.canGoToEntryDetail ? {
        href: '#',
        class: 'boss-table-4-link'
      } : {}
    },
    additionalListeners () {
      return this.canGoToEntryDetail ? {
        click: this.goToEntryDetail
      } : {}
    }
  },
  methods: {
    goToEntryDetail (event) {
      event.preventDefault()
      const targetRouteName = this.isEntry ? 'entryDetail' : 'seminarEntryDetail'
      this.$router.push({ name: targetRouteName, params: { entryId: this.entryId, tabKey: 'message' } })
    }
  }
}
</script>
